import React from 'react'

const React_Coding_Practice_30 = () => {
  return (
    <div>
      <h1>Coding Pratice 30</h1>
    </div>
  )
}

export default React_Coding_Practice_30
